import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  StationName: [],
  error: null,
};

export const looupNetworkNameDropdownSlice = createSlice({
  name: "getStations",
  initialState,
  reducers: {
    getDropData: (state, action) => {
      state.StationName = action.payload;
    },
  },
});

export const { getDropData } = looupNetworkNameDropdownSlice.actions;
